.upper-left {
  font-size: 0.875em;
  position: fixed;
  left: 0;
  top: 0;
  min-width: 4em;
  min-height: 4em;
  width: auto;
  height: auto;
  background: none;
  border: none;
  z-index: 1;
}

.panel-container {
  position: relative;
  height: 100%;
  width: 100%;
}
